import { Component, inject, OnInit } from "@angular/core";
import { ProductService } from "../services/product.service";
import { TableGroup } from "../models/tablegroup";
import QRCode from "qrcode";

import { ConfigService } from "../services/config.service";
import { Table } from "../models/table";
import { TextService } from "../services/text.service";
import { AsyncPipe } from "@angular/common";
import { ButtonComponent as TtButtonComponent } from "@ticket-team-com/tt-component-library";

@Component({
  selector: "app-qrcode",
  templateUrl: "./qrcode.component.html",
  styleUrls: ["./qrcode.component.css"],
  imports: [AsyncPipe, TtButtonComponent],
})
export class QrcodeComponent implements OnInit {
  public tableGroups: TableGroup[];

  private productService = inject(ProductService);
  private configService = inject(ConfigService);
  public textService = inject(TextService);

  ngOnInit() {
    this.getTables();
  }

  getTables() {
    this.productService.getAllTables().subscribe((response) => {
      this.tableGroups = response;
      console.log(this.tableGroups);
      this.generateCodes();
    });
  }

  generateCodes() {
    const codeUrl = this.configService.getConfig().qrCodeUrl;
    for (const tableGroupId in this.tableGroups) {
      for (const tableId in this.tableGroups[tableGroupId].tables) {
        const table = this.tableGroups[tableGroupId].tables[tableId];
        QRCode.toDataURL(codeUrl + table.id)
          .then((url) => {
            try {
              this.tableGroups[tableGroupId].tables[tableId].qrCode = url;
            } catch (e) {
              console.error(e);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType = "image/png",
    sliceSize = 512,
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  downloadImage(table: Table) {
    const parts = table.qrCode.split(",");
    const blobData = this.convertBase64ToBlobData(parts[1]);

    const fileName = table.id + ".png";

    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  }

  downloadAllImages() {
    let timeOut = 0;
    for (const tableGroup of this.tableGroups) {
      for (const table of tableGroup.tables) {
        setTimeout(() => {
          console.log(table);
          this.downloadImage(table);
        }, timeOut);
        timeOut += 500;
      }
    }
  }
}
